import { Pipe, PipeTransform } from '@angular/core';

// Models
import { POSITION_EXTRAS } from './../models/position.interface';

/**
 * `PositionExtraPipe` defines a pipe to translate position extra key.
 */
@Pipe({name: 'shePositionExtra'})
export class PositionExtraPipe implements PipeTransform {
  /**
   * Return value POSITION_EXTRAS.
   */
  transform(value: number): string {
    return POSITION_EXTRAS[value];
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/pipes/position-extra.pipe.ts